<template>
    <b-navbar-brand v-editable="blok" :href="blok.homepage_link.cached_link | formatSbInternalLink">
        <img class="brand-image" :src="blok.brand">
    </b-navbar-brand>
</template>
<script>
export default {
    name: 'navigation-logo',
    props: {
        'blok': {
            type: Object,
            required: true
        }
    }
}
</script>